import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import type { StudioDetails } from './types';

interface StudioState {
  currentStudio: StudioDetails | null;
  currentStudioId: string | null;
}

type SetCurrentStudio = (studio: StudioDetails) => void;

const initialStudioState: StudioState = {
  currentStudio: null,
  currentStudioId: null,
};

export const useStudioStore = create<
  StudioState & { setCurrentStudio: SetCurrentStudio }
>()(
  devtools(
    persist(
      (set) => ({
        ...initialStudioState,
        setCurrentStudio: (studio: StudioDetails) => {
          set((state) => ({
            ...state,
            currentStudio: studio,
            currentStudioId: studio._id,
          }));
        },
      }),
      {
        name: 'studio-storage',
      },
    ),
  ),
);

// Hook to access setCurrentStudio
export const useSetCurrentStudio = () =>
  useStudioStore((state) => state.setCurrentStudio);

// Function to set studio directly
export const setCurrentStudio = (studio: StudioDetails) => {
  useStudioStore.setState({
    currentStudio: studio,
    currentStudioId: studio._id,
  });
};

// Function to get studio directly
export const getCurrentStudio = () => {
  return useStudioStore.getState().currentStudio;
};

// Hook to access currentStudio
export const useCurrentStudio = () =>
  useStudioStore((state) => state.currentStudio);
